module.exports = __webpack_public_path__ + "static/media/dripEffect.17f42a0f.png";